import { render } from "./ResetPasswordFormV2.vue?vue&type=template&id=7a72f8f2"
import script from "./ResetPasswordFormV2.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFormV2.vue?vue&type=script&lang=js"

import "./ResetPasswordFormV2.vue?vue&type=style&index=0&id=7a72f8f2&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__